import { render } from "./BlocksWrapper.vue?vue&type=template&id=748b429c&scoped=true&ts=true"
import script from "./BlocksWrapper.vue?vue&type=script&lang=ts"
export * from "./BlocksWrapper.vue?vue&type=script&lang=ts"

import "./BlocksWrapper.vue?vue&type=style&index=0&id=748b429c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748b429c"]])

export default __exports__